export default __webpack_public_path__ + "static/media/tushar-khandagale-dvtAuBHBAVQ-unsplash.d5dfdcbc.jpg";